export default "__VITE_ASSET__3Y7y0X5r__"